const sadCorgi = document.querySelector("#sad-corgi");
const happyCorgi = document.querySelector("#happy-corgi");

function changeMood() {
  if (!happyCorgi.classList.contains("hide")) {
    happyCorgi.classList.add("hide");
    sadCorgi.classList.remove("hide");
  } else {
    happyCorgi.classList.remove("hide");
    sadCorgi.classList.add("hide");
  }
}

export function initCorgiMood() {
  sadCorgi.addEventListener("click", changeMood);
}